<div fxLayoutAlign="space-between center" fxLayout="row wrap">
  <p *ngIf="model" class="m-0">
    {{ model }}
  </p>
  <button class="my-12 mb-20" mat-raised-button (click)="openPopup()" >
    {{ field.title }}
  </button>
</div>